function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "discharging");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-cargo-operations",
  transform: "translate(-2.000000, -1.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M20,9.67 L20,9.5 C20.0124532,6.00795416 17.7446611,2.91661685 14.41,1.87999999 L14.35,1.87999999 C13.5110388,1.62423317 12.6369119,1.50273291 11.76,1.51999999 C7.42545057,1.75786617 4.02520348,5.32900197 3.99999999,9.67 C2.79905663,10.092469 1.99554004,11.2269152 1.99554004,12.5 C1.99554004,13.7730848 2.79905663,14.907531 3.99999999,15.33 C4.42671652,19.4213148 7.88655242,22.5221927 12,22.5001184 L12.23,22.5001184 C16.1945925,22.3080983 19.4410676,19.2814365 19.91,15.34 C21.1253439,14.9413362 21.9542671,13.8159552 21.9745671,12.5370566 C21.994867,11.258158 21.2020789,10.1070356 20,9.67 Z M12.18,20.5 C9.18670365,20.5865907 6.58783922,18.4528761 6.08999999,15.5 L17.86,15.5 C17.3574992,18.2834574 15.0047112,20.3545736 12.18,20.5 L12.18,20.5 Z M19,13.5 L4.99999999,13.5 C4.44771524,13.5 3.99999999,13.0522848 3.99999999,12.5 C3.99999999,11.9477153 4.44771524,11.5 4.99999999,11.5 L6.99999999,11.5 C7.55228475,11.5 7.99999999,11.0522847 7.99999999,10.5 C7.99999999,9.94771525 7.55228475,9.49999999 6.99999999,9.49999999 L5.99999999,9.49999999 C6.09087207,7.39404034 7.2129116,5.46787247 8.99999999,4.34999999 L8.99999999,7.49999999 C8.99999999,8.05228475 9.44771525,8.49999999 9.99999999,8.49999999 C10.5522847,8.49999999 11,8.05228475 11,7.49999999 L11,3.58999999 C11.2714301,3.54465194 11.5451956,3.5146045 11.82,3.49999999 L12,3.49999999 C12.335127,3.50471903 12.6694158,3.53480501 13,3.58999999 L13,7.49999999 C13,8.05228475 13.4477153,8.49999999 14,8.49999999 C14.5522848,8.49999999 15,8.05228475 15,7.49999999 L15,4.31999999 C15.4241954,4.56562434 15.819933,4.85739695 16.18,5.18999999 C17.3448714,6.32121236 18.001523,7.87624988 18,9.49999999 L17,9.49999999 C16.4477153,9.49999999 16,9.94771525 16,10.5 C16,11.0522847 16.4477153,11.5 17,11.5 L19,11.5 C19.5522848,11.5 20,11.9477153 20,12.5 C20,13.0522848 19.5522848,13.5 19,13.5 Z",
  id: "discharging"
})));

var SvgDischarging = function SvgDischarging(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDischarging, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discharging.6e424fa5.svg";
export { ForwardRef as ReactComponent };